import { render, staticRenderFns } from "./DropdownSort.vue?vue&type=template&id=79d2deba&scoped=true&"
import script from "./DropdownSort.vue?vue&type=script&lang=js&"
export * from "./DropdownSort.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSort.vue?vue&type=style&index=0&id=79d2deba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d2deba",
  null
  
)

export default component.exports